export const prepSleepOnset = (entries: any) => {
	let data: any = [];
	Object.values(entries).forEach((el: any) => {
		let TS = el.timeAsleep.split(":");
		let TSmin = parseInt(TS[0]) * 60 + parseInt(TS[1]);

		let TB = el.timeBed.split(":");
		let TBmin = parseInt(TB[0]) * 60 + parseInt(TB[1]);

		let latency = TSmin - TBmin;
		//check to see if value is negative (passes midnight);
		if (latency < 0) latency += 1440;

		data[el.dateTS] = { name: el.date, latency };
	});

	return Object.values(data);
};

export const prepExportSleepOnset = (entries: any) => {
	let data: any = [["date", "latency"]];
	Object.values(entries).forEach((el: any) => {
		let TS = el.timeAsleep.split(":");
		let TSmin = parseInt(TS[0]) * 60 + parseInt(TS[1]);

		let TB = el.timeBed.split(":");
		let TBmin = parseInt(TB[0]) * 60 + parseInt(TB[1]);

		let latency = TSmin - TBmin;
		//check to see if value is negative (passes midnight);
		if (latency < 0) latency += 1440;
    let result;
    if (latency > 0) result = latency;
    else result = '-';

		data[el.dateTS] = { name: el.date, result };
	});

	let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};

export const prepCCfrequency = (entries: any) => {
	let data: any = [];
	Object.values(entries).forEach((el: any) => {
		let frequency = el.numCurtainCalls;

		data[el.dateTS] = { name: el.date, frequency };
	});

	return Object.values(data);
};

export const prepExportCCfrequency = (entries: any) => {
	let data: any = [["date", "frequency"]];
	Object.values(entries).forEach((el: any) => {
		let frequency = el.numCurtainCalls;

		data[el.dateTS] = { name: el.date, frequency };
	});

	let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};

export const prepNWfrequency = (entries: any) => {
	let data: any = [];
	Object.values(entries).forEach((el: any) => {
		let frequency = el.numNightWakings;

		data[el.dateTS] = { name: el.date, frequency };
	});

	return Object.values(data);
};

export const prepExportNWfrequency = (entries: any) => {
	let data: any = [["date", "frequency"]];
	Object.values(entries).forEach((el: any) => {
		let frequency = el.numNightWakings;

		data[el.dateTS] = { name: el.date, frequency };
	});

	let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};

export const prepNWduration = (entries: any) => {
	let data: any = [];
	Object.values(entries).forEach((el: any) => {
		let duration = 0;

		el.nightWakings.forEach((el: any) => {
			duration += parseInt(el.NWduration);
		});

		data[el.dateTS] = { name: el.date, duration };
	});

	return Object.values(data);
};

export const prepExportNWduration = (entries: any) => {
	let data: any = [["date", "duration"]];
	Object.values(entries).forEach((el: any) => {
		let duration = 0;

		el.nightWakings.forEach((el: any) => {
			duration += parseInt(el.NWduration);
		});

		data[el.dateTS] = { name: el.date, duration };
	});

	let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};

export const prepareBitesFreqGraph = (entries: any) => {
  let data: any = [];
  Object.values(entries).forEach((el: any) => {
    let e: any = data[el.dateTS];
    let freq = e ? e.frequency : 0;

    Object.values(el.targetFood).forEach((idx: any) => {
      freq += parseInt(idx.numberBitesConsumed);
    });

    data[el.dateTS] = { name: el.date, frequency: freq };
  });

  return Object.values(data);
};

export const prepExportFreqBites = (entries: any) => {
  let data: any = [["date", "frequency"]];
  Object.values(entries).forEach((el: any) => {
    let e: any = data[el.dateTS];
    let freq = (e && e.frequency != undefined) ? e.frequency : 0;

    Object.values(el.targetFood).forEach((idx: any) => {
      freq += parseInt(idx.numberBitesConsumed);
    });

    data[el.dateTS] = { name: el.date, frequency: freq };
  });

  let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};

const sortByDate = (a: any, b: any) => {
  if (a.date > b.date) return 1;
  else if (a.date < b.date) return -1;
  else return 0;
};


export const prepareIndependenceGraph = (entries: any) => {
  let data: any = [];
  Object.values(entries)
    .sort(sortByDate)
    .forEach((el: any) => {
      let prior = data[el.dateTS];
      let indep = prior ? prior.indep : 0;
      let prompted = prior ? prior.prompted : 0;

      el.request === "independent" ? (indep += 1) : (prompted += 1);
      el.walking === "independent" ? (indep += 1) : (prompted += 1);
      el.undressing === "independent" ? (indep += 1) : (prompted += 1);
      el.sitting === "independent" ? (indep += 1) : (prompted += 1);
      el.flushing === "independent" ? (indep += 1) : (prompted += 1);
      el.dressing === "independent" ? (indep += 1) : (prompted += 1);

      if (el.defecation) {
        el.wiping === "independent" ? (indep += 1) : (prompted += 1);
      }

      let independence = parseFloat(
        ((indep / (indep + prompted)) * 100).toFixed(2)
      );

      data[el.dateTS] = { name: el.date, indep, prompted, independence };
    });

  return Object.values(data);
};

export const prepExportIndependenceGraph = (entries: any) => {
  let data: any = [["date", "independent", "prompted", "independence"]];
  Object.values(entries)
    .sort(sortByDate)
    .forEach((el: any) => {
      let prior = data[el.dateTS];
      let indep = (prior && prior.indep !== undefined) ? prior.indep : 0;
      let prompted = (prior && prior.prompted !== undefined) ? prior.prompted : 0;

      el.request === "independent" ? (indep += 1) : (prompted += 1);
      el.walking === "independent" ? (indep += 1) : (prompted += 1);
      el.undressing === "independent" ? (indep += 1) : (prompted += 1);
      el.sitting === "independent" ? (indep += 1) : (prompted += 1);
      el.flushing === "independent" ? (indep += 1) : (prompted += 1);
      el.dressing === "independent" ? (indep += 1) : (prompted += 1);

      if (el.defecation) {
        el.wiping === "independent" ? (indep += 1) : (prompted += 1);
      }

      let independence = parseFloat(
        ((indep / (indep + prompted)) * 100).toFixed(2)
      );

      data[el.dateTS] = { name: el.date, indep, prompted, independence };
    });

  let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};

export const prepareVoidsGraph = (entries: any) => {
  let data: any = [];
  Object.values(entries).forEach((el: any) => {
    let voids = data[el.dateTS] ? data[el.dateTS].voids : 0;
    let accidents = data[el.dateTS] ? data[el.dateTS].accidents : 0;

    if (el.defecation || el.urination) voids += 1;
    if (el.accidentDefecation || el.accidentUrination) accidents += 1;

    data[el.dateTS] = { name: el.date, voids: voids, accidents: accidents };
  });

  return Object.values(data);
};

export const prepExportVoidsGraph = (entries: any) => {
  let data: any = [["date", "voids", "accidents"]];
  Object.values(entries).forEach((el: any) => {
    let voids = data[el.dateTS] ? data[el.dateTS].voids : 0;
    let accidents = data[el.dateTS] ? data[el.dateTS].accidents : 0;

    if (el.defecation || el.urination) voids += 1;
    if (el.accidentDefecation || el.accidentUrination) accidents += 1;

    data[el.dateTS] = { name: el.date, voids: voids, accidents: accidents };
  });

  let exportData: any = [];
  Object.values(data).forEach((dp:any)=>{
    exportData.push(Object.values(dp));
  })

  return Object.values(exportData);
};
